export default "__VITE_ASSET__8504d6f6__"